import {useContext, useReducer} from 'react';
import {AuthContext} from '@mc/react-auth';
import {frameInitialState, FrameReducer} from '@mc/react-frame';
import {BaseProps} from '../props';

/**
 * Hook pro interních stavových properties mapové komponenty.
 *
 * @return properties.
 * @ignore
 */
export function useBaseProps(): BaseProps {
    const authState = useContext(AuthContext);
    const [frameState, frameDispatch] = useReducer(FrameReducer, frameInitialState);
    return {authState, frameState, frameDispatch};
}
